// 初期化
export const INIT = 'INIT'
// name入力
export const INPUT_NAME = 'INPUT_NAME'
// age入力
export const INPUT_AGE = 'INPUT_AGE'



// WEBPACK FOOTER //
// ./src/store/mutationsTypes.js